export const cacheKey = "/engagement/campaigns/:app_group_id/eligible" as const;
